import { IMoment } from '../interfaces/i-moment';

export const MOMENTS: IMoment[] = [
  {
    TextColor: '#378679',
    BackgroundColor: '#C9E9E4',
    StartTime: '08:00:00',
    EndTime: '10:00:00',
    Id: '2dcd8df9-6855-4021-97b8-c04ecc07c695',
    CreationDate: '2020-01-01T08:00:00',
    NameOrigin: 'Café da manhã',
  },
  {
    TextColor: '#936306',
    BackgroundColor: '#FCE4B6',
    StartTime: '12:00:00',
    EndTime: '15:00:00',
    Id: '89a07117-6a35-46a8-95fc-25263708e1b7',
    CreationDate: '2020-01-01T08:00:00',
    NameOrigin: 'Almoço',
  },
  {
    TextColor: '#D54415',
    BackgroundColor: '#FAFEB4',
    StartTime: '14:00:00',
    EndTime: '17:00:00',
    Id: '543b28b4-c910-45dc-9414-da8eeb6166a1',
    CreationDate: '2020-01-01T08:00:00',
    NameOrigin: 'Lanche',
  },
  {
    TextColor: '#3B2754',
    BackgroundColor: '#D7CBE7',
    StartTime: '17:00:00',
    EndTime: '20:00:00',
    Id: '93d83e2c-f246-434d-b00b-d7a347f934da',
    CreationDate: '2020-01-01T08:00:00',
    NameOrigin: 'Happy hour',
  },
  {
    TextColor: '#0A29C2',
    BackgroundColor: '#C5CEFC',
    StartTime: '20:00:00',
    EndTime: '23:00:00',
    Id: '89ba7a6a-79e1-4b42-993d-bee51776cb5b',
    CreationDate: '2020-01-01T08:00:00',
    NameOrigin: 'Jantar',
  },
];
